<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">8</h2>
<p class="vers"><span>Das Kind</span>, dem ein
fürstlich Kleid<br class="calibre1"/>
man anzog, und das Juwelen um seinen<br class="calibre1"/>
Nacken trägt, verliert alle Freude an seinem<br class="calibre1"/>
Spiel, behindert vom Kleid bei jedem Schritt.</p>
<p class="vers">Aus Furcht, es könnte zerreißen, vom<br class="calibre1"/>
Staube befleckt sein, hält es sich fern von<br class="calibre1"/>
der Welt und fürchtet beinah sich zu regen.</p>
<p class="vers">Mutter, es ist kein Gewinn im Zwang<br class="calibre1"/>
deines Putzes, wenn er uns ausschließt<br class="calibre1"/>
vom heilsamen Staube der Erde, wenn<br class="calibre1"/>
er des Rechts uns beraubt, hinzuzutreten<br class="calibre1"/>
zum großen Markt des gemeinen menschlichen<br class="calibre1"/>
Lebens. <a id="page11" title="wedi/cal"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?aa71bebe